import React, { useState } from 'react';
import { Calendar as CalendarIcon, Clock } from 'lucide-react';
import { format } from 'date-fns';
import { it, enUS } from 'date-fns/locale';
import { Button } from './ui/button';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

// Time slots every 15 minutes from 08:00 to 22:00
const TIME_SLOTS = (() => {
  const slots = [];
  for (let h = 8; h <= 22; h++) {
    for (let m = 0; m < 60; m += 15) {
      slots.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
    }
  }
  return slots;
})();

export const DatePicker = ({ value, onChange, language = 'it', placeholder, dataTestId }) => {
  const [open, setOpen] = useState(false);
  const dateLocale = language === 'it' ? it : enUS;
  const dateObj = value ? new Date(value) : null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="w-full justify-start text-left font-normal"
          data-testid={dataTestId}
        >
          <CalendarIcon size={16} className="mr-2" />
          {dateObj
            ? format(dateObj, 'PPP', { locale: dateLocale })
            : (placeholder || (language === 'it' ? 'Scegli data' : 'Pick a date'))}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={dateObj}
          onSelect={(d) => {
            if (d) {
              const iso = format(d, 'yyyy-MM-dd');
              onChange(iso);
              setOpen(false);
            }
          }}
          initialFocus
          disabled={(date) => date < new Date(new Date().setHours(0, 0, 0, 0))}
        />
      </PopoverContent>
    </Popover>
  );
};

export const TimePicker = ({ value, onChange, language = 'it', dataTestId }) => {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={dataTestId}>
        <div className="flex items-center gap-2">
          <Clock size={16} />
          <SelectValue placeholder={language === 'it' ? 'Scegli ora' : 'Pick a time'} />
        </div>
      </SelectTrigger>
      <SelectContent className="max-h-60">
        {TIME_SLOTS.map((slot) => (
          <SelectItem key={slot} value={slot}>
            {slot}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default { DatePicker, TimePicker };
